import { render, staticRenderFns } from "./email_title.vue?vue&type=template&id=2a44bfbe&scoped=true&"
import script from "./email_title.vue?vue&type=script&lang=js&"
export * from "./email_title.vue?vue&type=script&lang=js&"
import style0 from "./email_title.vue?vue&type=style&index=0&id=2a44bfbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44bfbe",
  null
  
)

export default component.exports